import { Component, OnInit } from '@angular/core';
import { AbstractDialogComponent, Product, ProductCatalogueStoreService } from '@motivforce/mx-library-angular';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { skip } from 'rxjs/operators';

@UntilDestroy()
@Component({
  selector: 'app-details-product-dialog',
  templateUrl: './details-product-dialog.component.html',
  styleUrls: ['./details-product-dialog.component.scss'],
})
export class DetailsProductDialogComponent extends AbstractDialogComponent implements OnInit {
  product: Product;

  shortDescirption: string;
  showLongDescription = false;
  showText = 'show more...';

  constructor(public activeModal: NgbActiveModal, private productCatalogueStore: ProductCatalogueStoreService) {
    super();
  }

  ngOnInit(): void {
    if (this.inputs && this.inputs.length > 0) {
      this.product = this.inputs[0];
      this.shortDescirption = this.product.shortDescription;
    }

    this.productCatalogueStore.currentProduct$
      .pipe(untilDestroyed(this), skip(1))
      .subscribe((product: Product | null) => {
        if (product) {
          if (this.product.id === product.id) {
            this.product = product;
          }
        }
      });
    this.productCatalogueStore.getProduct(this.product.id);
  }

  roundToHundred(value: number): number {
    return Math.round(value / 100) * 100;
  }

  onConfirm(): void {
    this.activeModal.close(true);
  }
}
